import React, { useState, useEffect } from 'react'
import './header.css'
import logo from '../pic/nas.png'

const Header = () => {
  // fixed Header
  window.addEventListener('scroll', function () {
    const header = document.querySelector('.header')
    header.classList.toggle('active', window.scrollY > 100)
  })
  // Toogle Menu
  const [Mobile, setMobile] = useState(false)

  return (
    <>
      <header className='header'>
        <div className='container d_flex'>
          <div className='logo'>
            <img src={logo} alt='' className='logo-img' />
          </div>

          <div className='navlink'>
            <ul
              className={Mobile ? 'nav-links-mobile' : 'link f_flex uppercase'}
              onClick={() => setMobile(false)}
            >
              {/*<ul className='link f_flex uppercase {Mobile ? "nav-links-mobile" : "nav-links"} onClick={() => setMobile(false)}'>*/}
              <li>
                <a href='#home'>home</a>
              </li>
              <li>
                <a href='#features'>Career</a>
              </li>
              <li>
                <a href='#portfolio'>portfolio</a>
              </li>
              <li>
                <a href='#resume'>resume</a>
              </li>
              {/* <li>
                <a href='#clients'>clients</a>
              </li> */}
              {/* <li>
                <a href='#blog'>blog</a>
              </li> */}
              <li>
                <a href='#contact'>contact</a>
              </li>
              <li>
                <a
                  href='/files/Nasution-Resume.pdf'
                  download='Nasution-Resume.pdf'
                >
                  <button className='home-btn'>Download CV</button>
                </a>
              </li>
            </ul>
            <a href='/files/Nasution-Resume.pdf' download='Nasution-Resume.pdf'>
              <button className='home-btn-download' id='download'>
                Download CV
              </button>
            </a>
            {/* <button className='toggle' onClick={() => setMobile(!Mobile)}>
              {Mobile ? (
                <i className='fas fa-times close home-btn'></i>
              ) : (
                <i className='fas fa-bars open'></i>
              )}
            </button> */}
          </div>
          <div className='navlink_for_mobile'>
            <ul
              className={
                Mobile ? 'nav-links-mobile' : 'link_mobile f_flex uppercase'
              }
              onClick={() => setMobile(false)}
            >
              <li>
                <a href='#home'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    // className='w-6 h-6'
                    style={{ height: '30px' }}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25'
                    />
                  </svg>
                  <span>home</span>
                </a>
              </li>
              {/* <li>
                <a href='#features'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    // className='w-6 h-6'
                    style={{height : '30px'}}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 01-1.125-1.125v-3.75zM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-8.25zM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 01-1.125-1.125v-2.25z'
                    />
                  </svg>
                </a>
              </li> */}
              <li>
                <a href='#portfolio'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    // className='w-6 h-6'
                    style={{ height: '30px' }}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M6.75 7.5l3 2.25-3 2.25m4.5 0h3m-9 8.25h13.5A2.25 2.25 0 0021 18V6a2.25 2.25 0 00-2.25-2.25H5.25A2.25 2.25 0 003 6v12a2.25 2.25 0 002.25 2.25z'
                    />
                  </svg>
                  <span>portfolio</span>
                </a>
              </li>
              <li>
                <a href='#resume'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    // className='w-6 h-6'
                    style={{ height: '30px' }}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5'
                    />
                  </svg>
                  <span>resume</span>
                </a>
              </li>
              {/* <li>
                <a href='#clients'>
                  <i class='fa-solid fa-users-rectangle'></i>
                </a>
              </li> */}
              <li>
                <a href='#features'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth={1.5}
                    style={{ height: '30px' }}
                  >
                    <path d='M7 10l5 5 5-5' />
                    <path d='M9 4h6M5 18h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2z' />
                  </svg>

                  <span>career</span>
                </a>
              </li>
              {/* <li>
                <a href='#contact'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    strokeWidth={1.5}
                    stroke='currentColor'
                    // className='w-6 h-6'
                    style={{height : '30px'}}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z'
                    />
                  </svg>
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
